'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/Loading.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-equals-spacing */


/*
Pflichtproperties:
me={this} 
modal={true/false} 
Id={this.props.Id}  
Title={} 
Content={}                                           

optional:
Width={330} Z={9999}
*/
var Loading = function (_Component) {
    _inherits(Loading, _Component);

    function Loading(props) {
        _classCallCheck(this, Loading);

        var _this = _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).call(this, props));

        _this.state = {};
        return _this;
    }

    _createClass(Loading, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.modal === true) {
                this.toggleModal();
            }

            this.LogoClick();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.modal === true) {
                this.toggleModal();
            }

            this.LogoClick();
        }
    }, {
        key: 'toggleModal',
        value: function toggleModal() {
            var modal = document.querySelector(".modalLoading");
            modal.classList.toggle("show-modalLoading");
        }
    }, {
        key: 'LogoClick',
        value: function LogoClick() {

            var kontrastNumber = localStorage.getItem('Kontrast');
            var role = localStorage.getItem("vas_role");

            if (kontrastNumber == "true") {

                (0, _jquery2.default)(".loader").attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87;');
                (0, _jquery2.default)('html body div#messageContainer div.modalLoading.show-modalLoading div.loader').attr('style', 'border-top: 16px solid #1d5c87; border-bottom: 16px solid #1d5c87;');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            (0, _jquery2.default)("#Content").css("opacity", "0.4");
            var className = '';
            if (this.props.modal === true) {
                className = "modalLoading";
            }
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement('div', { className: 'loader' })
            );
        }
    }]);

    return Loading;
}(_react.Component);

exports.default = Loading;